import { render, staticRenderFns } from "./FolderStructure.vue?vue&type=template&id=76cd38bc&"
import script from "./FolderStructure.vue?vue&type=script&lang=js&"
export * from "./FolderStructure.vue?vue&type=script&lang=js&"
import style0 from "./FolderStructure.vue?vue&type=style&index=0&id=76cd38bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports